import './PitcherSessionPitchTypeRangesChart.scss';

import { PitcherSessionPitchTypeRangesChartConfigDto, PitcherSessionPitchTypeRangesChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/SessionReport/Pitcher/reportStore';
import PitchTypeRanges from 'components/PitchTypeRanges/PitchTypeRanges';

const PitcherSessionPitchTypeRangesChart = ({
  chartData,
  isLoading,
  extraChartData,
}: ChartProps<PitcherSessionPitchTypeRangesChartDataDto, PitcherSessionPitchTypeRangesChartConfigDto>) => {
  const { selectedConfgValues } = useReportStore();

  return (
    <div className='PitcherSessionPitchTypeRangesChart-container'>
      <PitchTypeRanges
        pitchTypeRanges={chartData?.pitchTypeRanges}
        isLoading={isLoading}
        selectedMeasurementOption={extraChartData.selectedMeasurementOption}
        seePitchesBy={selectedConfgValues.pitchGrouping}
      />
    </div>
  );
};

export default PitcherSessionPitchTypeRangesChart;
